import CobaComp from '../components/cobaComp';

const Coba = () => {
    return (
        <div>
            <CobaComp />
        </div>
    );
};

export default Coba;
